import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { booksManageService } from '../api/booksManageService';
import type { BookFilterState, ManageBooksListResult } from '../types/manageBooks';

export function useBookListQuery(filters: BookFilterState) {
  return useQuery<ManageBooksListResult>({
    queryKey: ['manage-books', filters],
    queryFn: () => booksManageService.list(filters),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
